// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607201807/js/" + chunkId + "." + {"44":"16b7b159","225":"30054074","481":"a4cd87b6","486":"6c2b1825","770":"49819c3b"}[chunkId] + ".0.9309890572987041.chunk.js";
};